<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { ProjectProgress } from "@/types";

defineProps<{ progress: ProjectProgress; compact?: boolean }>();
const { t } = useI18n();
const stageLabel = (stage: string) =>
  ({
    intake: t("progress.intake"), solution_drafting: t("progress.drafting"), solution_review: t("progress.review"),
    project_draft: t("progress.draft"), submitted: t("progress.submitted"), team_accepted: t("progress.accepted"),
    scheduled: t("progress.scheduled"), in_progress: t("progress.inProgress"), awaiting_acceptance: t("progress.awaiting"),
    revision: t("progress.revision"), completed: t("progress.completed"),
  })[stage] || stage;
</script>

<template>
  <div class="progress" :class="{ compact }">
    <div class="progress__labels">
      <b>{{ progress.percent }}%</b>
      <span>{{ t("progress.completedCount", { done: progress.completedItems, total: progress.totalItems }) }}</span>
    </div>
    <div
      class="progress__track"
      role="progressbar"
      :aria-valuenow="progress.percent"
      aria-valuemin="0"
      aria-valuemax="100"
    ><span :style="{ width: `${progress.percent}%` }"></span></div>
    <div v-if="!compact" class="progress__meta">
      <span>{{ stageLabel(progress.stage) }}</span>
      <span v-if="progress.blockedItems" class="blocked">{{ t("progress.blockedCount", { count: progress.blockedItems }) }}</span>
      <span v-else-if="progress.delayed" class="delayed">{{ t("progress.delayed") }}</span>
      <span v-else>{{ progress.nextActor === "client" ? t("progress.waitClient") : t("progress.teamWorking") }}</span>
    </div>
  </div>
</template>

<style scoped>
.progress{display:grid;gap:7px;min-width:0}.progress__labels,.progress__meta{display:flex;align-items:center;justify-content:space-between;gap:10px}.progress__labels b{font-size:20px}.progress__labels span,.progress__meta{color:var(--muted);font-size:12px}.progress__track{height:8px;overflow:hidden;background:#e7ecec}.progress__track span{display:block;height:100%;background:var(--success);transition:width .2s ease}.blocked{color:var(--danger)}.delayed{color:#a65c00}.compact{gap:5px}.compact .progress__labels b{font-size:15px}.compact .progress__track{height:6px}
</style>
